export default __webpack_public_path__ + "static/media/mindmap.55699a41.svg";